import {
  PORTAL_GUIDE_SCREENSHOTS_VISIBLE,
  PORTAL_GUIDE_VIDEOS_VISIBLE,
} from 'data/constants/featureFlags';
import { isFlaggedCancellationsUiVisible } from 'utils/flaggedCancellationUi';
import { USER_ROLE_LABELS } from 'constants/userRoles';
import { APP_STAGE } from 'data/constants/common_constants';

export const PORTAL_GUIDE_TAB_KEYS = {
  GET_STARTED: 'get-started',
  DOCUMENTATION: 'documentation',
  FEATURED_VIDEOS: 'featured-videos',
};

const PORTAL_GUIDE_TABS = [
  {
    key: PORTAL_GUIDE_TAB_KEYS.GET_STARTED,
    title: 'Get started',
    icon: 'General.RocketLaunch',
  },
  {
    key: PORTAL_GUIDE_TAB_KEYS.DOCUMENTATION,
    title: 'Documentation',
    icon: 'FileFolder.StickyNote2',
  },
  {
    key: PORTAL_GUIDE_TAB_KEYS.FEATURED_VIDEOS,
    title: 'Featured videos',
    icon: 'MediaDevices.VideoLibrary',
    requiresVideos: true,
  },
];

export const isPortalGuideVideosVisible = () => PORTAL_GUIDE_VIDEOS_VISIBLE;

export const isPortalGuideScreenshotsVisible = () => PORTAL_GUIDE_SCREENSHOTS_VISIBLE;

export const getVisiblePortalGuideTabs = () =>
  PORTAL_GUIDE_TABS.filter((tab) => !tab.requiresVideos || PORTAL_GUIDE_VIDEOS_VISIBLE);

export const shouldShowTopbarGuideSlider = () => PORTAL_GUIDE_VIDEOS_VISIBLE;

/** Menu-aligned role labels for Portal Guide copy. */
export const PORTAL_GUIDE_ROLE_LABELS = USER_ROLE_LABELS;

export const PORTAL_GUIDE_POLICY_ISSUED_STAGE = APP_STAGE.Stage05;

export const PORTAL_GUIDE_APPLICATION_PROGRAMS =
  'Guarantor Waiver Program, Rent Guaranty, and LDR Commercial';

/** Hosted on landlord-portal S3 so Amplify SPA rewrites do not intercept playback. */
export const PORTAL_GUIDE_VIDEO_BASE_URL = (
  process.env.REACT_APP_PORTAL_GUIDE_VIDEO_BASE_URL ||
  'https://landlord-portal.s3.amazonaws.com/portal-guide/training'
).replace(/\/$/, '');

/** Partnerships training videos shown under Documentation → Training Videos. */
export const PORTAL_GUIDE_TRAINING_VIDEOS = [
  {
    title: 'How to Cancel a Policy in Leap Portal',
    src: `${PORTAL_GUIDE_VIDEO_BASE_URL}/how-to-cancel-a-policy.mp4`,
  },
  {
    title: 'How to View and Dispute Invoices',
    src: `${PORTAL_GUIDE_VIDEO_BASE_URL}/how-to-view-and-dispute-invoices.mp4`,
  },
  {
    title: 'How to File a Claim in the LEAP Portal',
    src: `${PORTAL_GUIDE_VIDEO_BASE_URL}/how-to-file-a-claim.mp4`,
  },
];

export const formatGuideList = (items) => {
  if (!items.length) {
    return '';
  }
  if (items.length === 1) {
    return items[0];
  }
  if (items.length === 2) {
    return `${items[0]} and ${items[1]}`;
  }
  return `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`;
};

export const getPropertyMenuGuideItems = () => {
  const items = ['Properties', 'Applications', 'Policies'];
  if (isFlaggedCancellationsUiVisible()) {
    items.push('Flagged Cancellations');
  }
  items.push('Claims');
  return items;
};

export const getSupportingRoleGuideLabels = () =>
  [PORTAL_GUIDE_ROLE_LABELS.vp, PORTAL_GUIDE_ROLE_LABELS.rm, PORTAL_GUIDE_ROLE_LABELS.pm].join(
    ', ',
  );
